import { ResourceLookUpConstants } from '../constants';
export const RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_ASSIGNEE_SHOP_INFO`;
export const RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO_SUCCESS = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_ASSIGNEE_SHOP_INFO_SUCCESS`;
export const RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO_FAILURE = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_ASSIGNEE_SHOP_INFO_FAILURE`;
export const getAssigneeShopInfoAction = (assigneeCode) => ({
    type: RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO,
    payload: assigneeCode
});
export const getAssigneeShopInfoSuccessAction = (assigneeShopInfo) => ({
    type: RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO_SUCCESS,
    payload: assigneeShopInfo
});
export const getAssigneeShopInfoFailureAction = (failureMessage) => ({
    type: RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=assigneeShopInfoActions.js.map